
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.24 47.6c-1.4.6-1 1.1-1.4.1-.3-.8.5-3.2.7-4 .4-2.1 1.2-4.6 1.2-6.8 0-4.1-4.9-7-7.5-9.6-.2-.2-.6-.5-.9-.8 1.1-.4 2.5-.3 3.6-.5 2.3-.3 5.7-.1 7.7-1.1 1.8-.8 2.4-3 3.2-4.7.5-1.1 2.3-6.4 4.1-6.8V10c-2.9.2-5.2 9.8-6.7 11.1-3.2 2.9-10.5-.2-13.5 3-3.2 3.5 4.9 9 6.6 10.8 2.2 2 2 1.1 1.5 4.1-.5 2.8-1.4 5.8-1.5 8.6-.1 6.5 6.8 1.1 9.6-.4 1.7-.9 2.7-1.6 3.9-1.5v-3.4c-3.4.1-7.7 4-10.6 5.3z"}})])
          )
        }
      }
    